import { Component, h, Host } from '@stencil/core';
export interface AhaCommentReply extends HTMLAhaCommentReplyElement {}

@Component({
  tag: 'aha-comment-reply',
  styleUrl: 'aha-comment-reply.css',
  shadow: true,
})
export class AhaCommentReply {
  render() {
    return (
      <Host>
        <div class="aha-comment-reply">
          <slot name="avatar" />
          <span class="aha-comment-reply__body">
            <slot name="body" />
          </span>
        </div>
      </Host>
    );
  }
}
